export default class FilterUserView {
    constructor(json) {
        this.id = json.id;
        this.label = json.name;
    }
}
